import { render, staticRenderFns } from "./BuildingForm.vue?vue&type=template&id=58302334&scoped=true&"
import script from "./BuildingForm.vue?vue&type=script&lang=ts&"
export * from "./BuildingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58302334",
  null
  
)

export default component.exports